import React, { useEffect, useState } from "react";
import { OrderStatus } from "../constants";
import { premiumPaths } from "../navigation";
import IssueConfirmationDialog from "./orders/IssueConfirmationDialog";
import OrderActions from "./OrderActions";

/** Wystawienie jest dostępne dopiero po przygotowaniu aktualnego podglądu. */
export default function IssueActions({ order, ready, busy, approve, save }) {
  const [confirmation, setConfirmation] = useState(null);
  const canIssue =
    ready &&
    !busy &&
    order.status === OrderStatus.REVIEW &&
    order.previewRevision === order.revision;
  useEffect(() => {
    setConfirmation((current) =>
      !canIssue ||
      current?.id !== order.id ||
      current?.revision !== order.revision
        ? null
        : current,
    );
  }, [order.id, order.revision, canIssue]);
  return (
    <>
      <section className="card premium-panel">
        <h2>Wystaw świadectwo</h2>
        <p className="text-muted">
          Podgląd aktualnych danych jest gotowy. Potwierdź wystawienie
          świadectwa, aby otrzymać dokument z numerem i podpisem.
        </p>
        <dl className="premium-issue-summary">
          <dt>Eksporter</dt>
          <dd style={{ whiteSpace: "pre-line" }}>{order.config.exporter}</dd>
          <dt>Faktura</dt>
          <dd>{order.draft.invoiceNumbers || "Nie podano"}</dd>
          <dt>Odbiorca</dt>
          <dd>{order.draft.recipient.name || "Nie podano"}</dd>
        </dl>
      </section>
      {canIssue && (
        <OrderActions
          backTo={premiumPaths.preview(order.id)}
          backLabel="Podgląd świadectwa"
          save={save}
          nextLabel="Zapisz i wystaw świadectwo"
          onNext={() =>
            setConfirmation({ id: order.id, revision: order.revision })
          }
        />
      )}
      {confirmation?.id === order.id &&
        confirmation?.revision === order.revision &&
        canIssue && (
          <IssueConfirmationDialog
            order={order}
            onCancel={() => setConfirmation(null)}
            onConfirm={() => {
              setConfirmation(null);
              approve();
            }}
          />
        )}
    </>
  );
}
